// START GENAI@CHATGPT4
import { Component, Prop, State, Element, h } from "@stencil/core";
import { getDataFromPropString } from "../../utils/utils";

@Component({
  tag: "vs-ect",
  styleUrl: "./_vs-ect.scss",
})
export class ExpandableContentTile {
  @Element() el: HTMLVsEctElement;
  @Prop() contentBundleData: string | JSON;
  @Prop() displayPublishDate: string = "yes";
  @Prop() layout: string = "content-library";
  @Prop() playAriaLabel = "Play";
  @Prop() headerId?: string = "contentLibraryBundleHeader";
  @Prop() rankInContainer = 0;
  @State() screenWidth = 0;
  private observer: IntersectionObserver;
  // @State() headerHeight = 0;

  allProps = {};
  layoutClass = "vs-ct-2-up";
  altClass = '';
  overlayClass = '';
  classStyle = 'h2';
  private peekabooTimeDuration = 5000;

  componentWillLoad() {
    this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.allProps = typeof this.contentBundleData === "string" ? getDataFromPropString(this.contentBundleData) : this.contentBundleData;
    this.layoutClass = this.layout === "2up" ? "vs-ct-2-up" : "vs-ct-3-up";
    this.classStyle = this.layout === '3up' ? 'vs-h3' : 'vs-h2';
    this.peekabooTimeDuration = this.allProps['peekabooTimeDuration'] || 5000;

    const gradientOverlay = this.allProps['gradientOverlay'];
    const overlayTypes = {
      'black': 'vs-bg-black vs-bg-black-gradient',
      'primary': 'vs-bg-primary vs-bg-primary-gradient',
      'primaryDark': 'vs-bg-primary-dark vs-bg-primary-dark-gradient',
    };

    this.altClass = ['black', 'primaryDark', 'primary'].includes(gradientOverlay) ? 'vs-alt' : '';
    this.overlayClass = overlayTypes[gradientOverlay] || 'vs-bg-tertiary-1 vs-bg-tertiary-1-gradient';
    window.addEventListener('resize', this.resizeEventHandler);
    document.addEventListener('scroll', this.applyPeekabooEffect);
  }



  componentDidLoad() {
    const maxVisibleTimes = 3;
    let visibleCount = 0;
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.applyOverlayStyles();
          visibleCount++;
          if (visibleCount >= maxVisibleTimes) {
            this.observer.unobserve(this.el);
          }
        }
      });
    });
    this.observer.observe(this.el); // Begin observing the element
  }
componentDidRender() {
    this.applyPeekabooEffect();
  }
  componentWillUpdate() {
    this.allProps = typeof this.contentBundleData === "string" ? getDataFromPropString(this.contentBundleData) : this.contentBundleData;
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.unobserve(this.el);
    }
    document.removeEventListener('scroll', this.applyPeekabooEffect);
  }
  private resizeEventHandler = () => {
    this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.applyOverlayStyles();
  };

  private applyOverlayStyles = () => {
    const ect = this.el.querySelector('.vs-ct') as HTMLElement;
    const overlayDiv = this.el.querySelector('.vs-ct-overlay') as HTMLElement;
    const headerText = this.allProps['headerText'];
    let headerElement;

    switch (this.allProps['headerStyle']) {
      case 'h2':
        headerElement = this.el.querySelector('h2');
        break;
      case 'h3':
        headerElement = this.el.querySelector('h3');
        break;
      case 'h4':
        headerElement = this.el.querySelector('h4');
        break;
      default:
        headerElement = null;
    }

    // Get the computed styles for the header element
     var computedStyles = window.getComputedStyle(headerElement);

    // Get the height from the computed styles
    var height = computedStyles.height;
   // Parse the height to get a number (removing the 'px' unit)
    var heightValue = parseFloat(height);
    if (!ect || !overlayDiv) {
      return;
    }
    let headerHeight = 0;

    switch (true) {
      case this.screenWidth >= 1200:
        if (ect.classList.contains('vs-ct-2-up')) {
          headerHeight = headerText?.length > 25 ? 76 : 40;
        } else if ((ect.classList.contains('vs-ct-3-up'))) {
          headerHeight = heightValue > 60 ? 75 : (headerText?.length > 25 ? 55 : 30);
        }
        break;
      case this.screenWidth >= 992:
        if (ect.classList.contains('vs-ct-2-up')) {
          headerHeight = headerText?.length > 25 ? 55 : 29;
        } else if ((ect.classList.contains('vs-ct-3-up'))) {
          headerHeight = headerText?.length > 25 ? 44 : 23;
        }
        break;

    }
    const overlayTransform = `translateY(calc(100% - ${90 + headerHeight}px))`;
    if (this.screenWidth >=992 && !overlayDiv.classList.contains('vs-peekaboo')) {
      overlayDiv.style.transform = overlayTransform;
    } else {
      overlayDiv.style.transform = '';
    }

  }

  private applyPeekabooEffect = () => {
    const overlayDiv = this.el.querySelector('.vs-ct-overlay');
    const element = this.el.querySelector('.vs-ct');
    if (this.screenWidth >= 992 && !overlayDiv.classList.contains("vs-ct-scrolled") && this.isInViewport(element)) {
      overlayDiv.classList.add("vs-ct-scrolled", "vs-peekaboo");
      setTimeout(() => {
        overlayDiv.classList.remove("vs-peekaboo");
      }, this.peekabooTimeDuration + (100 * this.rankInContainer));
    }
  }

  private isInViewport = (element) => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  render() {
    return (
      <div data-layout={this.layout} class={`${this.layoutClass} vs-ct vs-ect vs-animation-link ${this.overlayClass}`}>
        <img src={this.allProps['desktopImagePath']} alt={this.allProps['desktopAltText']} class="vs-d-none vs-d-lg-block vs-ct-image vs-img-placeholder" />
        <img src={this.allProps['mobileImagePath']} alt={this.allProps['mobileAltText']} class="vs-d-lg-none vs-ct-image vs-img-placeholder" />
        <div class={this.overlayClass + ' vs-ct-overlay'}>
          {this.allProps['headerStyle'] === 'h2' && <h2 class={`${this.classStyle} ${this.altClass}`} innerHTML={this.allProps['headerText']}></h2>}
          {this.allProps['headerStyle'] === 'h3' && <h3 class={`${this.classStyle} ${this.altClass}`} innerHTML={this.allProps['headerText']}></h3>}
          {this.allProps['headerStyle'] === 'h4' && <h4 class={`${this.classStyle} ${this.altClass}`} innerHTML={this.allProps['headerText']}></h4>}
          <ul class="vs-py-2">
            {this.allProps['ctas'].map((ctaItem) => (
              <li>
                {ctaItem.ctaLinkTarget !== 'modal' ?
                  <vs-link
                    link-aria-label={ctaItem.ctaLinkAriaLabel}
                    button-color={ctaItem.ctaButtonColor}
                    link-conversion={ctaItem.ctaConversionType}
                    link-type={ctaItem.ctaLinkType}
                    link-style={ctaItem.ctaStyle}
                    has-dark-bg={this.altClass === 'vs-alt' ? 'yes' : 'no'}
                    link-target={ctaItem.ctaLinkTarget}
                    link-text={ctaItem.ctaTitle}
                    img-path={ctaItem.ctaVideoImagePath}
                    link-val={ctaItem.ctaLink}
                    is-no-follow={ctaItem?.ctaNoFollow}
                  ></vs-link> :
                  <vs-link
                    link-aria-label={ctaItem.ctaLinkAriaLabel}
                    button-color={ctaItem.ctaButtonColor}
                    link-conversion={ctaItem.ctaConversionType}
                    link-type={ctaItem.ctaLinkType}
                    link-style={ctaItem.ctaStyle}
                    has-dark-bg={this.altClass === 'vs-alt' ? 'yes' : 'no'}
                    link-target={ctaItem.ctaLinkTarget}
                    link-text={ctaItem.ctaTitle}
                    img-path={ctaItem.ctaVideoImagePath}
                    modal-target={ctaItem.ctaUniqueId}
                    link-val={ctaItem.ctaLink}
                    is-no-follow={ctaItem?.ctaNoFollow}
                    ></vs-link>
                }
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}
